import { StrapiImage } from "@/types/strapi";
import { BASE_URL } from "@/utils/const";

export function resolveMediaUrl(url: string): string {
	return /^https?:\/\//.test(url) ? url : BASE_URL + url;
}

export function mapImage(
	image: StrapiImage | null | undefined,
	responsive: boolean,
):
	| {
			url: string;
			width: number;
			height: number;
			mime: string;
			alternativeText: string;
			srcSet?: {
				small: string;
				medium: string;
				large: string;
			};
	  }
	| null
	| undefined {
	if (!image) return null;

	return {
		url: resolveMediaUrl(image.url),
		width: image.width,
		height: image.height,
		mime: image.mime,
		alternativeText: image.alternativeText ?? "",
		...(responsive && {
			srcSet: {
				small: resolveMediaUrl(image.formats.small.url),
				medium: resolveMediaUrl(image.formats.medium.url),
				large: resolveMediaUrl(image.formats.large.url),
			},
		}),
	};
}
